<div id="main-content" class="wrapper has-padding margin-height zoom-margin" (focusout)="onFocusOutMainContent($event)">
  <form *ngIf="criminalHistoryData ;  else loading" [formGroup]="criminalHistoryForm" (ngSubmit)="onSubmit()">

    <div *ngIf="hasApplicantHistory() || isSwapsAp()">
      <h1 class="bofa--heading is-4">Applicant history</h1>
    </div>

    <div *ngIf="hasApplicantHistory()">
      <div *ngIf="criminalHistoryForm.controls.creditAssignedFlag.value != -1" class="bottom-space">
        <span class="minor-list-space" id="criminal-assigned-label-1"><abbr title="required">* </abbr>Do you have any
          unsatisfied judgments or liens against you?</span>
        <mat-radio-group name="radioJudgments" aria-describedby="criminal-assigned-label-1"
          formControlName="usCriminalCreditAssigned" required class="minor-radio-padding radio-flex"
          (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
          <mat-radio-button class="minor-list-space radio-padding field-space" value="1"
            name="usCriminalCreditAssigned">Yes</mat-radio-button>
          <mat-radio-button value="0" class="field-space" name="usCriminalCreditAssigned">No</mat-radio-button>
        </mat-radio-group>

        <mat-error
          *ngIf="hasBeenSubmittted && criminalHistoryForm.controls.usCriminalCreditAssigned.hasError('required')">
          Please select Do you have any unsatisfied judgments or liens against you?
        </mat-error>
      </div>

      <!-- Hidden divs are for screen readers -->
      <div class="bofa--skiplink">
        <mat-error *ngIf="hasBeenSubmittted && showRadioJudgment">Please select if you have any unsatisfied judgments
          or liens against you?</mat-error>
      </div>

      <div *ngIf="usCriminalCreditAssigned.value == 1" id="details">
        <span class="global-red">Please provide details of the lien/judgment to the best of your knowledge
          including:</span>
        <ul class="global-red margin-notop">
          <li>Plaintiff/Creditor</li>
          <li>Balance</li>
          <li>State/County of filing</li>
          <li>Date of filing</li>
          <li>Current payment arrangement</li>
        </ul>
      </div>

      <div *ngIf="usCriminalCreditAssigned.value == 1" class="bottom-space">
        <mat-form-field class="resize">
          <mat-label id="details-1" aria-labelledby="details">Details</mat-label>
          <textarea class="textarea-resize" matInput formControlName="usCriminalUnsatisfiedComments" maxlength="4000"
            cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="50"
            aria-labelledby="details-1"></textarea>
          <mat-hint align="end">
            {{usCriminalUnsatisfiedComments.value.length}} / 4000
          </mat-hint>
        </mat-form-field>
      </div>

      <div *ngIf="criminalHistoryForm.controls.safeRegistrationFlag.value != -1" class="bottom-space">
        <span class="minor-list-space" id="safe-registration-label"><abbr title="required">* </abbr>Have you ever had
          active registration with NMLS?</span>
        <mat-radio-group name="radioNMLS" aria-describedby="safe-registration-label"
          formControlName="usCriminalSafeRegistration" required class="bottom-space minor-radio-padding radio-flex"
          (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
          <mat-radio-button class="minor-list-space radio-padding field-space" value="1"
            name="usCriminalSafeRegistration">Yes</mat-radio-button>
          <mat-radio-button value="0" class="field-space" name="usCriminalSafeRegistration">No
          </mat-radio-button>
        </mat-radio-group>

        <mat-error
          *ngIf="hasBeenSubmittted && criminalHistoryForm.controls.usCriminalSafeRegistration.hasError('required')">
          Please select Have you ever had active registration with NMLS?
        </mat-error>
      </div>

      <!-- Hidden divs are for screen readers -->
      <div class="bofa--skiplink">
        <mat-error *ngIf="hasBeenSubmittted && showRadioNMLS">Please select have you ever had active registration with
          NMLS?</mat-error>
      </div>

      <div *ngIf="usCriminalSafeRegistration.value == 1">
        <mat-form-field class="max-zoom field-space non-required max-width width-margin">
          <mat-label>Please provide NMLS number</mat-label>
          <input matInput formControlName="usCriminalNMLSNumber" maxlength="150">
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="isSwapsAp()">
      <div class="bottom-space">
        <span class="minor-list-space" id="criminal-assigned-label-2"><abbr title="required">* </abbr>Do you have a
          record
          of any denial of membership or registration, and of any disciplinary action taken, or sanction imposed, upon
          you by any federal or state agency, or by any national securities exchange or national securities association,
          including any finding you were the cause of any disciplinary action or had violated any law?</span>
        <mat-radio-group name="radioSwapsDisciplinaryAction" aria-describedby="criminal-assigned-label-2"
          formControlName="swapsDisciplinaryAction" required class="minor-radio-padding radio-flex"
          (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
          <mat-radio-button class="minor-list-space radio-padding field-space" value="1">Yes</mat-radio-button>
          <mat-radio-button value="0" class="field-space">No</mat-radio-button>
        </mat-radio-group>

        <mat-error
          *ngIf="hasBeenSubmittted && criminalHistoryForm.controls.swapsDisciplinaryAction.hasError('required')">
          Please select Swaps question?
        </mat-error>
      </div>

      <div *ngIf="swapsDisciplinaryAction.value == 1" class="bottom-space">
        <mat-form-field class="resize">
          <mat-label id="details-2" aria-labelledby="details">Details</mat-label>
          <textarea class="textarea-resize" matInput formControlName="swapsDisciplinaryActionDetails" maxlength="4000"
            cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="50"
            aria-labelledby="details-2"></textarea>
          <mat-hint align="end">
            {{swapsDisciplinaryActionDetails.value.length}} / 4000
          </mat-hint>
        </mat-form-field>
      </div>

      <div class="bottom-space">
        <span class="minor-list-space" id="criminal-assigned-label-3"><abbr title="required">* </abbr>Do you have a
          record
          of any denial, suspension, expulsion or revocation of membership or registration of any broker, dealer,
          security-based swap dealer or major security-based swap participant with which you were associated in any
          capacity at the time such action was taken?</span>
        <mat-radio-group name="radioSwapsRevocation" aria-describedby="criminal-assigned-label-3"
          formControlName="swapsRevocation" required class="minor-radio-padding radio-flex"
          (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
          <mat-radio-button class="minor-list-space radio-padding field-space" value="1">Yes</mat-radio-button>
          <mat-radio-button value="0" class="field-space">No</mat-radio-button>
        </mat-radio-group>

        <mat-error *ngIf="hasBeenSubmittted && criminalHistoryForm.controls.swapsRevocation.hasError('required')">
          Please select Swaps question?
        </mat-error>
      </div>

      <div *ngIf="swapsRevocation.value == 1" class="bottom-space">
        <mat-form-field class="resize">
          <mat-label id="details-3" aria-labelledby="details">Details</mat-label>
          <textarea class="textarea-resize" matInput formControlName="swapsRevocationDetails" maxlength="4000"
            cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="50"
            aria-labelledby="details-3"></textarea>
          <mat-hint align="end">
            {{swapsRevocationDetails.value.length}} / 4000
          </mat-hint>
        </mat-form-field>
      </div>

      <div class="bottom-space">
        <span class="minor-list-space" id="criminal-assigned-label-4"><abbr title="required">* </abbr>Do you have a
          record
          of any permanent or temporary injunction entered against you, or any broker, dealer, security-based swap
          dealer or major security-based swap participant with which you were associated in any capacity at the time
          such injunction was entered?</span>
        <mat-radio-group name="radioSwapsInjunction" aria-describedby="criminal-assigned-label-4"
          formControlName="swapsInjunction" required class="minor-radio-padding radio-flex"
          (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
          <mat-radio-button class="minor-list-space radio-padding field-space" value="1">Yes</mat-radio-button>
          <mat-radio-button value="0" class="field-space">No</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="hasBeenSubmittted && criminalHistoryForm.controls.swapsInjunction.hasError('required')">
          Please select Swaps question?
        </mat-error>
      </div>

      <div *ngIf="swapsInjunction.value == 1" class="bottom-space">
        <mat-form-field class="resize">
          <mat-label id="details-4" aria-labelledby="details">Details</mat-label>
          <textarea class="textarea-resize" matInput formControlName="swapsInjunctionDetails" maxlength="4000"
            cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="50"
            aria-labelledby="details-4"></textarea>
          <mat-hint align="end">
            {{swapsInjunctionDetails.value.length}} / 4000
          </mat-hint>
        </mat-form-field>
      </div>

      <div class="bottom-space">
        <span class="minor-list-space" id="criminal-assigned-label-5"><abbr title="required">* </abbr>Do you have a
          record
          of any arrest or indictment for any felony, or any misdemeanor pertaining to securities, commodities, banking,
          insurance or real estate (including, but not limited to, acting or being associated with a broker or dealer,
          security-based swap dealer, major security-based swap participant, investment company, investment adviser,
          futures sponsor, bank, or savings and loan association), fraud, false statements or omissions, wrongful taking
          of property or bribery, forgery, counterfeiting or extortion, and the disposition of the foregoing?</span>
        <mat-radio-group name="radioSwapsRecordofArrest" aria-describedby="criminal-assigned-label-5"
          formControlName="swapsRecordofArrest" required class="minor-radio-padding radio-flex"
          (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
          <mat-radio-button class="minor-list-space radio-padding field-space" value="1" name="swapsRecordofArrest">Yes
          </mat-radio-button>
          <mat-radio-button value="0" class="field-space" name="swapsRecordofArrest">No</mat-radio-button>
        </mat-radio-group>

        <mat-error *ngIf="hasBeenSubmittted && criminalHistoryForm.controls.swapsRecordofArrest.hasError('required')">
          Please select Swaps question?
        </mat-error>
      </div>

      <div *ngIf="swapsRecordofArrest.value == 1" class="bottom-space">
        <mat-form-field class="resize">
          <mat-label id="details-5" aria-labelledby="details">Details</mat-label>
          <textarea class="textarea-resize" matInput formControlName="swapsRecordofArrestDetails" maxlength="4000"
            cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="50"
            aria-labelledby="details-5"></textarea>
          <mat-hint align="end">
            {{swapsRecordofArrestDetails.value.length}} / 4000
          </mat-hint>
        </mat-form-field>
      </div>
    </div>

    <h1 class="bofa--heading is-4">Criminal history</h1>

    <div *ngIf="criminalHistoryForm.controls.awaitTrialFlag.value != -1" class="bottom-space">
      <span class="minor-list-space" id="await-trial-label"><abbr title="required">* </abbr>Are you awaiting trial for
        or have you ever been
        convicted of a felony or misdemeanor offense?</span>
      <mat-radio-group name="radioAwaitTrial" aria-describedby="await-trial-label"
        formControlName="usCriminalAwaitTrial" required class="bottom-space minor-radio-padding radio-flex"
        (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
        <mat-radio-button class="minor-list-space radio-padding field-space" value="1" name="usCriminalAwaitTrial">Yes
        </mat-radio-button>
        <mat-radio-button value="0" class="field-space" name="usCriminalAwaitTrial">No</mat-radio-button>
      </mat-radio-group>

      <mat-error *ngIf="hasBeenSubmittted && criminalHistoryForm.controls.usCriminalAwaitTrial.hasError('required')">
        Please select Are you
        awaiting trial for or have you ever been convicted of a felony or misdemeanor offense?
      </mat-error>

      <div *ngIf="criminalHistoryForm.controls.usCriminalAwaitTrial.value == 1" class="global-red criminal-space">
        In the Offense/Regulatory Action Details section below, please list the details of <strong>each</strong> offense
        <strong>separately</strong> (using the Add Offense/Regulatory Action button) along with an explanation for
        <strong>each</strong>.
      </div>
    </div>

    <!-- Hidden divs are for screen readers -->
    <div class="bofa--skiplink">
      <mat-error *ngIf="hasBeenSubmittted && showRadioAwaitingTrial">Please select Are you
        awaiting trial for or have you ever been convicted of a felony or misdemeanor offense?</mat-error>
    </div>

    <div *ngIf="criminalHistoryForm.controls.pendingChargesFlag.value != -1" class="bottom-space">
      <span class="minor-list-space" id="pending-label"><abbr title="required">* </abbr>Do you have any pending criminal
        charges?</span>
      <mat-radio-group name="radioPendingCharges" aria-describedby="pending-label" formControlName="usCriminalPending"
        required class="bottom-space minor-radio-padding radio-flex" (change)="radioOnChange($event)"
        (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
        <mat-radio-button class="minor-list-space radio-padding field-space" value="1" name="usCriminalPending">Yes
        </mat-radio-button>
        <mat-radio-button value="0" class="field-space" name="usCriminalPending">No</mat-radio-button>
      </mat-radio-group>

      <mat-error *ngIf="hasBeenSubmittted && criminalHistoryForm.controls.usCriminalPending.hasError('required')">
        Please select Do you have any pending criminal charges?
      </mat-error>

      <div *ngIf="criminalHistoryForm.controls.usCriminalPending.value == 1" class="global-red criminal-space">
        In the Offense/Regulatory Action Details section below, please list the details of <strong>each</strong> offense
        <strong>separately</strong> (using the Add Offense/Regulatory Action button) along with an explanation for
        <strong>each</strong>.
      </div>
    </div>

    <!-- Hidden divs are for screen readers -->
    <div class="bofa--skiplink">
      <mat-error *ngIf="hasBeenSubmittted && showRadioPendingCharges">Please select Do you have any pending criminal
        charges?</mat-error>
    </div>

    <div *ngIf="criminalHistoryForm.controls.convictedOffenseFlag.value != -1" class="bottom-space">
      <span class="minor-list-space" id="convictions-label"><abbr title="required">* </abbr>Have you ever been convicted
        of a criminal
        offense, pleaded
        no contest to charges or agreed to enter in a pre-trial diversion or similar program in lieu of a
        criminal prosecution for any crime?</span>
      <mat-radio-group name="radioConvicted" aria-describedby="convictions-label"
        formControlName="usCriminalConvictions" required class="bottom-space minor-radio-padding radio-flex"
        (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
        <mat-radio-button class="minor-list-space radio-padding field-space" value="1" name="usCriminalConvictions">Yes
        </mat-radio-button>
        <mat-radio-button value="0" class="field-space" name="usCriminalConvictions">No</mat-radio-button>
      </mat-radio-group>

      <mat-error *ngIf="hasBeenSubmittted && criminalHistoryForm.controls.usCriminalConvictions.hasError('required')">
        Please select Have you ever been convicted of a criminal offense, pleaded
        no contest to charges or agreed to enter in a pre-trial diversion or similar program in lieu of a
        criminal prosecution for any crime?
      </mat-error>

      <div *ngIf="criminalHistoryForm.controls.usCriminalConvictions.value == 1" class="global-red criminal-space">
        In the Offense/Regulatory Action Details section below, please list the details of <strong>each</strong> offense
        <strong>separately</strong> (using the Add Offense/Regulatory Action button) along with an explanation for
        <strong>each</strong>.
      </div>
    </div>

    <!-- Hidden divs are for screen readers -->
    <div class="bofa--skiplink">
      <mat-error *ngIf="hasBeenSubmittted && showRadioConvicted">Please select Have you ever been convicted of a
        criminal offense, pleaded no contest to charges or agreed to enter in a pre-trial diversion or similar program
        in lieu of a criminal prosecution for any crime?</mat-error>
    </div>

    <div *ngIf="criminalHistoryForm.controls.dispositionAdjudicationFlag.value != -1" class="bottom-space">
      <span class="minor-list-space" id="dispositions-label"><abbr title="required">* </abbr>Have you accepted a
        disposition of adjudication
        withheld on any criminal charge?</span>
      <mat-radio-group name="radioDisposition" aria-describedby="dispositions-label"
        formControlName="usCriminalDispositions" required class="bottom-space minor-radio-padding radio-flex"
        (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
        <mat-radio-button class="minor-list-space radio-padding field-space" value="1" name="usCriminalDispositions">Yes
        </mat-radio-button>
        <mat-radio-button value="0" class="field-space" name="usCriminalDispositions">No</mat-radio-button>
      </mat-radio-group>

      <mat-error *ngIf="hasBeenSubmittted && criminalHistoryForm.controls.usCriminalDispositions.hasError('required')">
        Please
        select Have you accepted a disposition of adjudication withheld on any criminal charge?
      </mat-error>

      <div *ngIf="criminalHistoryForm.controls.usCriminalDispositions.value == 1" class="global-red criminal-space">
        In the Offense/Regulatory Action Details section below, please list the details of <strong>each</strong> offense
        <strong>separately</strong> (using the Add Offense/Regulatory Action button) along with an explanation for
        <strong>each</strong>.
      </div>
    </div>

    <!-- Hidden divs are for screen readers -->
    <div class="bofa--skiplink">
      <mat-error *ngIf="hasBeenSubmittted && showRadioDisposition">Please select Have you accepted a disposition of
        adjudication withheld on any criminal charge?</mat-error>
    </div>

    <div *ngIf="criminalHistoryForm.controls.subjectInvestigationFlag.value != -1" class="bottom-space">
      <span class="minor-list-space" id="investigation-label"><abbr title="required">* </abbr>Have you, or a business in
        which you are/were
        substantially involved, ever been the subject of any
        investigation or enforcement proceeding by a local, state or federal financial institution regulator, for
        example, the Securities Exchange Commission,
        Federal Trade Commission, Office of the Comptroller of the Currency, or Federal Deposit Insurance Corporation,
        or any State regulatory agency?</span>
      <mat-radio-group name="radioInvestigation" aria-describedby="investigation-label"
        formControlName="usCriminalSubjectInvestigation" required class="bottom-space minor-radio-padding radio-flex"
        (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
        <mat-radio-button class="minor-list-space radio-padding field-space" value="1"
          name="usCriminalSubjectInvestigation">Yes</mat-radio-button>
        <mat-radio-button value="0" class="field-space" name="usCriminalSubjectInvestigation">No
        </mat-radio-button>
      </mat-radio-group>

      <mat-error
        *ngIf="hasBeenSubmittted && criminalHistoryForm.controls.usCriminalSubjectInvestigation.hasError('required')">
        Please select Have you, or a business in which you are/were substantially involved, ever been the subject of
        any investigation or enforcement proceeding by a local, state or federal financial institution regulator, for
        example, the Securities Exchange Commission, Federal Trade Commission, Office of the Comptroller of the
        Currency, or Federal Deposit Insurance Corporation,
        or any State regulatory agency?
      </mat-error>

      <div *ngIf="criminalHistoryForm.controls.usCriminalSubjectInvestigation.value == 1" class="criminal-space">
        <mat-form-field class="max-zoom field-space width-margin" hideRequiredMarker>
          <mat-label id="explanation-1"><abbr title="required">* </abbr>Explanation</mat-label>
          <textarea matInput formControlName="usCriminalSubjectInvestigationComments" required maxlength="1000"
            aria-labelledby="explanation-1"></textarea>
          <mat-hint align="end">
            {{(criminalHistoryForm.controls.usCriminalSubjectInvestigationComments.value)?criminalHistoryForm.controls.usCriminalSubjectInvestigationComments.value.length:0}}
            / 1000</mat-hint>
          <mat-error>Please enter the explanation</mat-error>
        </mat-form-field>
        <br />
        <span class="global-red">
          Also in the Offense/Regulatory Action Details section below, please list the details of <strong>each</strong>
          offense
          <strong>separately</strong> (using the Add Offense/Regulatory Action button) along with an explanation for
          <strong>each</strong>.
        </span>
      </div>
    </div>

    <!-- Hidden divs are for screen readers -->
    <div class="bofa--skiplink">
      <mat-error *ngIf="hasBeenSubmittted && showRadioInvestigation">Please select Have you, or a business in which you
        are/were substantially involved, ever been the subject of
        any investigation or enforcement proceeding by a local, state or federal financial institution regulator, for
        example, the Securities Exchange Commission, Federal Trade Commission, Office of the Comptroller of the
        Currency, or Federal Deposit Insurance Corporation,
        or any State regulatory agency?</mat-error>
    </div>

    <div *ngIf="criminalHistoryForm.controls.respondentFinancialFlag.value != -1" class="bottom-space">
      <span class="minor-list-space" id="financial-label"><abbr title="required">* </abbr>Have you ever been named as a
        respondent/defendant in a financial services-related
        consumer-initiated arbitration or civil litigation which resulted in a judgment against you or was settled for
        any amount?</span>
      <mat-radio-group name="radioRespondent" aria-describedby="financial-label"
        formControlName="usCriminalRespondentFinancial" required class="bottom-space minor-radio-padding radio-flex"
        (change)="radioOnChange($event)" (focusin)="radioOnFocus($event)" (focusout)="radioOnFocusOut($event)">
        <mat-radio-button class="minor-list-space radio-padding field-space" value="1"
          name="usCriminalRespondentFinancial">Yes</mat-radio-button>
        <mat-radio-button value="0" class="field-space" name="usCriminalRespondentFinancial">No
        </mat-radio-button>
      </mat-radio-group>

      <mat-error
        *ngIf="hasBeenSubmittted && criminalHistoryForm.controls.usCriminalRespondentFinancial.hasError('required')">
        Please select Have you ever been named as a respondent/defendant in a financial services-related
        consumer-initiated arbitration or civil litigation which resulted in a judgment against you or was settled for
        any amount?
      </mat-error>

      <div *ngIf="criminalHistoryForm.controls.usCriminalRespondentFinancial.value == 1" class="criminal-space">
        <mat-form-field class="max-zoom field-space width-margin" hideRequiredMarker>
          <mat-label id="explanation-2"><abbr title="required">* </abbr>Explanation</mat-label>
          <textarea matInput formControlName="usCriminalRespondentFinancialComments" required maxlength="1000"
            aria-labelledby="explanation-2"></textarea>
          <mat-hint align="end">
            {{(criminalHistoryForm.controls.usCriminalRespondentFinancialComments.value)?criminalHistoryForm.controls.usCriminalRespondentFinancialComments.value.length:0}}
            / 1000</mat-hint>
          <mat-error>Please enter the explanation</mat-error>
        </mat-form-field>
        <br />
        <span class="global-red">
          Also in the Offense/Regulatory Action Details section below, please list the details of <strong>each</strong>
          offense
          <strong>separately</strong> (using the Add Offense/Regulatory Action button) along with an explanation for
          <strong>each</strong>.
        </span>
      </div>
    </div>

    <!-- Hidden divs are for screen readers -->
    <div class="bofa--skiplink">
      <mat-error *ngIf="hasBeenSubmittted && showRadioRespondent">Please select Have you ever been named as a
        respondent/defendant in a financial services-related consumer-initiated arbitration or civil litigation which
        resulted in a judgment against you or was settled for any amount?</mat-error>
    </div>

    <div *ngIf="showOffenseList">
      <div class="flex-40">
        <div class="is-taller padding-0">
          <div class="level">
            <div class="level-item">
              <h2 class="bofa--heading is-6 flex-heading">Enter your offense details</h2>
            </div>
          </div>
        </div>

        <div>
          <div *ngFor="let criminalOffenseForm of criminalOffenseList.controls; let i = index"
            [formGroup]="criminalOffenseForm">
            <mat-accordion multi="true" *ngIf="step === i">
              <mat-expansion-panel [class.border]="border" class="af-mat-card mat-elevation-z panel-width"
                [expanded]="step === i" [hideToggle]="true" (opened)="setStep(i)" id="i">
                <mat-expansion-panel-header class="mat-expansion outlined background-w">
                  <mat-panel-title>
                    Offense/Regulatory Action {{i+1}}
                  </mat-panel-title>
                  <mat-panel-description>
                    <div class="float-r"><img src="assets/bofa_icon_close2_186rgb.svg" tabindex="0"
                        (keyup.enter)="deleteClick(i)" (click)="deleteClick(i)" class="height-20"
                        alt="Remove offense" /></div>
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <!-- set focus when pressing Add button -->
                <div tabindex="-1" #addElement class="bofa--skiplink">
                </div>

                <mat-form-field class="minor-list-space max-zoom field-space max-width width-350" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Offense/Regulatory Action</mat-label>
                  <mat-select formControlName="offenseOrRegulatoryAction" required>
                    <mat-option>Select</mat-option>
                    <mat-option
                      *ngFor="let offenseType of criminalHistoryData.offenseTypelookup | keyvalue : valueAscOrderOtherLast"
                      [value]="offenseType.value">
                      {{offenseType.value}}
                    </mat-option>
                  </mat-select>
                  <mat-hint class="bofa--skiplink">
                    {{ dropDownScreenReaderOffense(criminalOffenseForm) }}
                  </mat-hint>
                  <mat-error *ngIf="criminalOffenseForm.controls.offenseOrRegulatoryAction.hasError('required') ">Please
                    enter Offense or Regulatory Action
                  </mat-error>
                </mat-form-field>

                <div *ngIf="criminalOffenseForm.controls.offenseOrRegulatoryAction.value == 'Other'">
                  <mat-form-field class="max-zoom field-space max-width width-margin" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Offense/Regulatory Action Other Comment</mat-label>
                    <input matInput formControlName="othrCmtOffenseType" required maxlength="50">
                    <mat-error>Please enter Offense/Regulatory Action Other Comment
                    </mat-error>
                  </mat-form-field>
                </div>

                <mat-form-field class="max-zoom field-space max-width width" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Level of Offense</mat-label>
                  <mat-select formControlName="levelOfOffense" required>
                    <mat-option>Select</mat-option>
                    <mat-option
                      *ngFor="let offenseLevel of criminalHistoryData.offenseLevelLookup | keyvalue : valueAscOrderOtherLast"
                      [value]="offenseLevel.key">
                      {{offenseLevel.value}}
                    </mat-option>
                  </mat-select>
                  <mat-hint class="bofa--skiplink">
                    {{ dropDownScreenReaderOffenseLevel(criminalOffenseForm) }}
                  </mat-hint>
                  <mat-error *ngIf="criminalOffenseForm.controls.levelOfOffense.hasError('required') ">Please select
                    Level of Offense
                  </mat-error>
                </mat-form-field>

                <!-- Other -->
                <div *ngIf="criminalOffenseForm.controls.levelOfOffense.value == 16">
                  <mat-form-field class="max-zoom field-space max-width width-margin" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Level of Offense Other Comment</mat-label>
                    <input matInput formControlName="othrCmtLevelOfOffense" required maxlength="50">
                    <mat-error>Please enter Level of Offense Other Comment
                    </mat-error>
                  </mat-form-field>
                </div>

                <mat-form-field class="max-zoom field-space minor-list-space max-width width" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Country</mat-label>
                  <mat-select formControlName="country" required>
                    <mat-option>Select</mat-option>
                    <mat-option *ngFor="let country of criminalHistoryData.countryLookup | keyvalue : valueAscOrder"
                      [value]="country.key">
                      {{country.value}}
                    </mat-option>
                  </mat-select>
                  <mat-hint class="bofa--skiplink">
                    {{ dropDownScreenReaderCountry(criminalOffenseForm) }}
                  </mat-hint>
                  <mat-error *ngIf="criminalOffenseForm.controls.country.hasError('required') ">Please select
                    Country
                  </mat-error>
                </mat-form-field>

                <div *ngIf="criminalOffenseForm.controls.country.value ==186">
                  <mat-form-field class="max-zoom field-space max-width width" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>State</mat-label>
                    <mat-select formControlName="usState">
                      <mat-option>Select</mat-option>
                      <mat-option *ngFor="let us of criminalHistoryData.usStateLookup | keyvalue : valueAscOrder"
                        [value]=us.key>
                        {{us.value}}
                      </mat-option>
                    </mat-select>
                    <mat-hint class="bofa--skiplink">
                      {{ dropDownScreenReaderState(criminalOffenseForm) }}
                    </mat-hint>
                    <mat-error *ngIf="criminalOffenseForm.controls.usState.hasError('required') ">Please select State
                    </mat-error>
                  </mat-form-field>
                </div>

                <div *ngIf="criminalOffenseForm.controls.country.value !=186"
                  class="non-required middle-width minor-list-space">
                  <mat-form-field class="max-width width-310">
                    <mat-label>State</mat-label>
                    <input matInput formControlName="stateOrProvince">
                  </mat-form-field>
                </div>

                <div class="non-required middle-width minor-list-space">
                  <mat-form-field class="max-width width-310">
                    <mat-label>County (List N/A if not applicable)</mat-label>
                    <input matInput formControlName="county">
                  </mat-form-field>
                </div>

                <div class="non-required middle-width minor-list-space">
                  <mat-form-field class="max-width width-310">
                    <mat-label>City/Town</mat-label>
                    <input matInput formControlName="cityOrTown">
                  </mat-form-field>
                </div>

                <mat-form-field class="max-zoom field-space minor-list-space max-width hint-padding width"
                  hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Offense Date</mat-label>
                  <input matInput [matDatepicker]="dateOfOffensePicker" [min]="minDate" [max]="maxDate"
                    formControlName="dateOfOffense" required>
                  <mat-datepicker-toggle matSuffix [for]="dateOfOffensePicker"></mat-datepicker-toggle>
                  <mat-datepicker #dateOfOffensePicker></mat-datepicker>
                  <mat-hint>Format mm/dd/yyyy</mat-hint>
                  <mat-error *ngIf="criminalOffenseForm.controls.dateOfOffense.errors">Please enter valid offense date
                  </mat-error>
                </mat-form-field>

                <div class="non-required middle-width minor-list-space hint-padding">
                  <mat-form-field class="max-width width-310">
                    <mat-label> Arrest Date</mat-label>
                    <input matInput [matDatepicker]="dateOfArrestPicker" [min]="minDate" [max]="maxDate"
                      formControlName="dateOfArrest">
                    <mat-datepicker-toggle matSuffix [for]="dateOfArrestPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateOfArrestPicker></mat-datepicker>
                    <mat-hint>Format mm/dd/yyyy</mat-hint>
                  </mat-form-field>
                </div>

                <div class="non-required middle-width minor-list-space hint-padding">
                  <mat-form-field class="max-width width-310">
                    <mat-label> Disposition Date</mat-label>
                    <input matInput [matDatepicker]="dateOfDispositionPicker" [min]="minDate" [max]="maxDate"
                      formControlName="dateOfDisposition">
                    <mat-datepicker-toggle matSuffix [for]="dateOfDispositionPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateOfDispositionPicker></mat-datepicker>
                    <mat-hint>Format mm/dd/yyyy</mat-hint>
                  </mat-form-field>
                </div>

                <mat-form-field class="max-zoom field-space max-width width" hideRequiredMarker>
                  <mat-label><abbr title="required">* </abbr>Disposition</mat-label>
                  <mat-select formControlName="disposition">
                    <mat-option>Select</mat-option>
                    <mat-option
                      *ngFor="let dispositionLu of criminalHistoryData.dispositionlookup | keyvalue : valueAscOrderOtherLast"
                      [value]=dispositionLu.key>
                      {{dispositionLu.value}}
                    </mat-option>
                  </mat-select>
                  <mat-hint class="bofa--skiplink">
                    {{ dropDownScreenReaderDisposition(criminalOffenseForm) }}
                  </mat-hint>
                  <mat-error *ngIf="criminalOffenseForm.controls.disposition.hasError('required') ">Please select
                    Disposition
                  </mat-error>
                </mat-form-field>

                <!-- Other -->
                <div *ngIf="criminalOffenseForm.controls.disposition.value == 9">
                  <mat-form-field class="max-zoom field-space max-width width-margin" hideRequiredMarker>
                    <mat-label><abbr title="required">* </abbr>Disposition Other Comment</mat-label>
                    <input matInput formControlName="othrCmtDisposition" required maxlength="100">
                    <mat-error>Please enter Disposition Other Comment
                    </mat-error>
                  </mat-form-field>
                </div>

                <div class="non-required-textarea minor-list-space">
                  <mat-form-field class="width-310">
                    <mat-label id="sentence-label">Sentence</mat-label>
                    <textarea matInput formControlName="sentence" maxlength="1000"
                      aria-labelledby="sentence-label"></textarea>
                    <mat-hint align="end">
                      {{(criminalOffenseForm.controls.sentence.value)?criminalOffenseForm.controls.sentence.value.length:0}}
                      / 1000
                    </mat-hint>
                  </mat-form-field>
                </div>

                <mat-form-field class="max-zoom field-space max-width width-margin" hideRequiredMarker>
                  <mat-label id="offense-explanation-label"><abbr title="required">* </abbr>Explanation</mat-label>
                  <textarea matInput formControlName="explanation" required maxlength="1000"
                    aria-labelledby="offense-explanation-label"></textarea>
                  <mat-hint align="end">
                    {{(criminalOffenseForm.controls.explanation.value)?criminalOffenseForm.controls.explanation.value.length:0}}
                    / 1000</mat-hint>
                  <mat-error>Please enter Explanation</mat-error>
                </mat-form-field>
                <div class="is-taller remove-button-align">
                  <button type="button" class="bofa--button primary outlined" (click)="deleteClick(i)">Remove this
                    Offense/Regulatory Action</button>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </div>
    </div>

    <!-- Vertical View -->
    <div *ngIf="showOffenseList">
      <div>
        <div class="is-taller">
          <div class="level">
            <div><span class="bofa--heading is-6">Review your offenses</span>
            </div>
            <div> <button #addButtonElement [disabled]="criminalOffenseList.invalid" type="button"
                class="bofa--button secondary" (click)="onAddCriminalHistory()">Add offense</button>
            </div>
          </div>
        </div>

        <div>
          <mat-selection-list *ngIf="listCheck" (selectionChange)="handleSelection($event)">
            <mat-list-option *ngFor="let criminalOffenseForm of criminalOffenseList.controls; let i = index" [value]="i"
              [selected]="step === i" (click)="focusTarget()" (keyup.enter)="focusTarget()">
              <div class="is-taller">
                <div class="level">
                  <div class="width-padding-margin"><span *ngIf="!criminalOffenseForm.invalid">
                      <img src="assets/bofa_icon_checkmark2.svg" class="review-icon" alt="check" /></span>
                    <span *ngIf="criminalOffenseForm.invalid">
                      <img src="assets/bofa_icon_alert.svg" class="review-icon" alt="error" />
                    </span>
                    <span class="padding-l">{{i+1}}</span>
                  </div>
                  <div class="width-max">
                    {{criminalOffenseForm.controls.offenseOrRegulatoryAction.value | slice:0:20}}
                  </div>
                  <div class="width-45">
                    <span *ngIf="criminalOffenseForm.controls.dateOfOffense.value!=null">
                      {{criminalOffenseForm.controls.dateOfOffense.value | dateFormat }}
                    </span>
                  </div>
                </div>
              </div>
              <mat-divider aria-hidden="true"></mat-divider>
            </mat-list-option>
          </mat-selection-list>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template #loading>
  Loading Criminal history...
</ng-template>